import RoleForm from "./RoleForm";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";
import { useGetRoleByIdQuery } from "./rolesApi";
import { hasPermission } from "../../../helpers/utils/AccessControlUtils";
import { fetchWithExtraOptions, tgxApi } from "../../../app/tgxApi";

const UpdateRole = () => {

    let { roleId } = useParams();
    // @ts-ignore
    fetchWithExtraOptions(tgxApi.endpoints.getRoleById, { roleId }, {
        redirectToErrorPage: true,
        skip: !roleId
    });
    const [crumbs, setCrumbs] = useState<any[]>([]);

    const roleByIdQuery = useGetRoleByIdQuery(roleId ?? skipToken);
    const [roleData, setRoleData] = useState<any>({});

    useEffect(() => {
        let roleObj = roleByIdQuery?.data;
        if (roleObj) {
            setCrumbs([
                { content: "Home", url: "/home" },
                { content: "Roles", url: "/roles" },
                { content: roleObj?.name, url: "" }
            ]);

            document.title = `${roleObj?.name}`;
        }
    }, [roleByIdQuery]);
    useEffect(() => {
        if (roleByIdQuery?.data) {
            const { name, authorityLevel } = roleByIdQuery.data;
            setRoleData({ name, authorityLevel });
        }
    }, [roleByIdQuery?.data]);

    return (
        <>
            <RoleForm crumbs={crumbs} title={"Update Role"} btnText={"Update"} isReadOnly={hasPermission(["ROL-U"]) === false}
                roleId={roleId} setRoleData={setRoleData} roleData={roleData} roleByIdQuery={roleByIdQuery}/>

        </>
    )
}
export default UpdateRole;